import { IIconProps } from "../types"

export default function IconLL7(props: IIconProps) {
  const width = props.size || props.width || 106
  const height = props.size || props.height || 75
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 106 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.9648 2.45293C90.9848 1.54293 88.4448 0.692932 85.2848 0.492932C82.1248 0.302932 78.3548 0.752932 74.6748 1.44293C70.9948 2.12293 67.4148 3.03293 63.1548 3.72293C58.8848 4.40293 53.9348 4.86293 48.4748 4.69293C43.0048 4.53293 37.0148 3.75293 32.7748 3.20293C28.5448 2.64293 26.0748 2.32293 23.8948 2.74293C21.7148 3.16293 19.8248 4.34293 17.5748 5.31293C15.3348 6.29293 12.7248 7.07293 10.4848 7.82293C8.23485 8.57293 6.34485 9.28293 4.81485 11.0429C3.28485 12.8029 2.11485 15.6029 1.34485 18.6229C0.574846 21.6529 0.204846 24.9029 0.624846 30.2129C1.05485 35.5129 2.26485 42.8729 3.10485 48.8329C3.93485 54.7929 4.39485 59.3529 5.59485 62.7729C6.80485 66.1829 8.75485 68.4629 11.6548 70.0329C14.5548 71.5929 18.3948 72.4329 24.1848 72.9929C29.9848 73.5429 37.7248 73.8029 47.0048 73.9029C56.2848 74.0029 67.0948 73.9329 74.2148 73.7029C81.3448 73.4829 84.7948 73.0929 87.3048 72.4029C89.8148 71.7229 91.3748 70.7429 92.5748 69.5029C93.7848 68.2729 94.6248 66.7729 96.7448 60.8129C98.8648 54.8629 102.245 44.4429 103.845 37.5729C105.435 30.7029 105.245 27.3829 104.725 24.2229C104.195 21.0729 103.355 18.0729 102.145 14.9529C100.945 11.8229 99.3848 8.57293 97.8848 6.45293C96.3848 4.34293 94.9548 3.36293 92.9648 2.45293Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
      <path
        d="M50.1648 5.70312C49.3848 16.5731 48.6048 27.4531 48.4748 33.2131C48.3448 38.9731 48.8648 39.6231 52.1148 41.7731C55.3748 43.9231 61.3648 47.5631 67.3548 51.2131"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
      <path
        d="M48.7837 38.1934C42.8037 41.2334 36.8137 44.2734 33.8837 45.8534C30.9537 47.4334 31.0837 47.5734 31.2137 47.5034C31.3437 47.4334 31.4737 47.1734 31.6037 46.9134"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
